var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoAlertError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.2 0C0.537258 0 0 0.537259 0 1.2L0 10.8C0 11.4627 0.537259 12 1.2 12H10.8C11.4627 12 12 11.4627 12 10.8V1.2C12 0.537258 11.4627 0 10.8 0L1.2 0ZM5 2.2C5 1.97909 5.17909 1.8 5.4 1.8L6.6 1.8C6.82091 1.8 7 1.97909 7 2.2V6.6C7 6.82091 6.82091 7 6.6 7H5.4C5.17909 7 5 6.82091 5 6.6V2.2ZM5 8.2C5 7.97909 5.17909 7.8 5.4 7.8H6.6C6.82091 7.8 7 7.97909 7 8.2V9.4C7 9.62091 6.82091 9.8 6.6 9.8H5.4C5.17909 9.8 5 9.62091 5 9.4V8.2Z",
    fill: "#CC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlertError);
export default __webpack_public_path__ + "static/media/ico_alert_error.165d956f.svg";
export { ForwardRef as ReactComponent };